(function() {
    angular.module('tmx-app').factory('tmxResource', ['$http', '$q','$state','APP_CONSTANTS', 'ToastService', 
        function ($http, $q, $state,APP_CONSTANTS, ToastService) {

            function tmxResourceFactory(entityName) {

                var Resource = function (data) {
                    angular.extend(this, data);
                };

            
                var url = APP_CONSTANTS.backend +  entityName;// + '/' + entityName;
                Resource.url=url;
                var defaultParams = {};
                if (APP_CONSTANTS.apiKey) {
                    defaultParams.apiKey = APP_CONSTANTS.apiKey;
                }
                Resource.defaultParams=defaultParams;


            //var token = "Bearer SgHt2smLw4oIJCFE8PRqprFVzmZ9Q98zdO0Vi-ZwXo3oNSfu6Twqicy04UhY1TWfM-d3UHzUst6gBzW0QjUFQh2tijBStIPnWI3JHrirl8gkM6D8LL3Cz6PTgd3aXDcKeOXo_Xkl1BWVP0fkAUMEz527rc6wqkCCY-MYodK2KItixBJ0IPELuLVosDevrXa693XYggOjdKur6MbRjNjYOISi-CAT_r57zf2gZlg6AQZCGWyQrBfOlpTnGJZk3J0mpErJzzJprHLKrAcPys9ta-I8Q9zodFjfc4RI26dmYVuNkFfCrkxsqvcYRJqmHBxJ91VblmcPhvRcJ6Zh-nltr5qJrg4";

                var thenFactoryMethod = function (httpConfig, successcb, errorcb, isArray,deferredAbort) {
                    deferredAbort= $q.defer();
                    httpConfig.timeout=deferredAbort.promise;
                    var httpPromise=$http(httpConfig);
                    var promise= httpPromise.then(function (response) {
                        var result;
                        if (isArray) {
                            if(!angular.isDefined(response.data.data) && angular.isDefined(response.data.Data)){
                                response.data.data=response.data.Data;
                            }
                            result = [];
                            if(angular.isDefined(response.data.data) && response.data.data!=null) {

                                for (var i = 0; i < response.data.data.length; i++) {
                                    result.push(new Resource(response.data.data[i]));
                                }
                            }
                        }
                        else {
                            if (response.data === " null ") {
                                return $q.reject({
                                    code: 'resource.notfound',
                                    collection: entityName
                                });
                            }
                            else {
                                if(response.data==="") {
                                    result = new Resource(response.config.data);
                                }
                                else if(response.data.data){
                                    result = new Resource(response.data.data);
                                }
                                else {
                                    result = new Resource(response.data);
                                }
                            }
                        }

                    //scb(result, response.status, response.headers, response.config);
                    //


                    //////////////////////////////////////////////////////////////////////////
                        if(response.config.method=="POST" && response.statusText=="OK" && response.data &&  response.data.status && response.data.status.message) {
                            ToastService.showCustomToast("success",response.data.status.message);
                        //ToastService.showCustomToast("success",entityName+" "+response.config.data[entityName+"Name"]+" is Created Successfully");
                        }
                        else if(response.config.method=="POST" && response.statusText=="Created") {
                        // if(angular.isDefined(response.config.data[entityName+"Name"])){
                        //    ToastService.showCustomToast("success",entityName+" has been created successfully with the name "+response.config.data[entityName+"Name"]);
                        //  }
                        // else{
                        //     ToastService.showCustomToast("success",entityName+" has been created successfully");
                        // }
                            if(angular.isDefined(response.data.status)) {
                                if(!response.data.status.message.startsWith("Suc") && !response.data.status.message.startsWith("No")) {
                                    ToastService.showCustomToast("success",response.data.status.message);
                                }
                            // ToastService.showCustomToast("success",entityName+" "+response.config.data[entityName+"Name"]+" is Updated Successfully");   
                            }

                        }

                        if(response.config.method=="PUT" && response.statusText=="OK") {
                         
                            if(angular.isDefined(response.data.status)) {
                                if(!response.data.status.message.startsWith("Suc") && !response.data.status.message.startsWith("No")) {
                                    ToastService.showCustomToast("success",response.data.status.message);
                                }
                            // ToastService.showCustomToast("success",entityName+" "+response.config.data[entityName+"Name"]+" is Updated Successfully");   
                            }
                        }
                        else if(response.status=="404") {
                            ToastService.showCustomToast("error","Some Error Occured");
                        }
                        else if(response.status=="400") {
                            ToastService.showCustomToast("error","Invalid Request");
                        }
                        var obj=response.data;
                        if(typeof (response.data) == 'object') {
                            obj.data=result;
                        }                    
                        return obj;
                    }, function (response) {
                        if(response.status == 401) {
                            $state.go('public.login');
                        }
                        else {
                        // ecb(undefined, response.status, response.headers, response.config);
                            return response;
                        }                    
                    });
                    promise.cancel=function(){
                        deferredAbort.resolve();
                    }
                // Since we're creating functions and passing them out of scope,
                // we're creating object references that may be hard to garbage
                // collect. As such, we can perform some clean-up once we know
                // that the requests has finished.
                    promise.finally(
                        function() {
                            promise.cancel = angular.noop;
                            // eslint-disable-next-line no-undef
                            deferredAbort = request = promise = null;
                        }
                    );

                    return promise;
                };

                Resource.thenFactoryMethod=thenFactoryMethod;


                Resource.all = function (cb, errorcb) {
                 
                    return Resource.query({}, cb, errorcb);
                };

                function httpConfig(method,url,data){
                    this.url=url;
                    this.method=method;
                    this.data=data;
                }

                Resource.query = function (queryJson, successcb, errorcb) {
                  //  var params = angular.isObject(queryJson) ? {q: JSON.stringify(queryJson)} : {};
                // var httpPromise = $http.get(url ); /*, {headers: {'Authorization': token}});*/
                    return thenFactoryMethod(new httpConfig('get',url), successcb, errorcb, true);
                };

                Resource.createResourceObject = function(data){
                    return new Resource(data);
                }

                Resource.getById = function (id, successcb, errorcb) {
                // var httpPromise = $http.get(url + '/' + id); /*, {headers: {'Authorization': token}});*/
                    return thenFactoryMethod(new httpConfig('get',url+ '/' + id), successcb, errorcb);
                };
                Resource.getByActionWithParams = function (params, action, isArray, method,data, filterStr, successcb, errorcb) {
                    var _params={}, qs1;

                    if(!angular.isDefined(action)){
                        action="";
                    }
                    if(angular.isDefined(params.data.take))
                        _params.take=params.data.take;
                    if(params.data.firstPage) {
                        _params.page=1;
                        _params.skip=0;
                    }
                    else {
                        if(angular.isDefined(params.data.page))
                            _params.page=params.data.page;
                        if(angular.isDefined(params.data.skip))
                            _params.skip=params.data.skip;
                    }
                    if(angular.isDefined(params.data.pageSize))
                        _params.pageSize=params.data.pageSize;

                // add sorting
                    if(angular.isDefined(params.data.sort) && params.data.sort.length>0){
                        qs1 = "sort=" + params.data.sort[0].field + "-" + params.data.sort[0].dir;
                    }


                    var qs=$.param(_params)+'&'+qs1;

                // var httpPromise = $http.get(url +action+ '?' + qs ); /*, {headers: {'Authorization': token}});*/
                    if(!angular.isDefined(method))
                        method="get";
                    var config={};
                    switch(method){
                    case "put":
                        // httpPromise = $http.put(url + '/' + action,data);
                        config= new httpConfig('put',url + '/' + action+ '?' + qs + "&"+filterStr,data);
                        break;
                    case "get":
                        //httpPromise = $http.get(url + '/' + action );
                        config= new httpConfig('get',url + '/' + action);
                        break;
                    }


                    return thenFactoryMethod(config, successcb, errorcb,isArray);
                }
                Resource.getByAction = function (action, isArray,method,data,successcb, errorcb) {
                // var httpPromise;
                    if(!angular.isDefined(method))
                        method="get";
                    var config={};
                    switch(method){
                    case "put":
                        // httpPromise = $http.put(url + '/' + action,data);
                        config= new httpConfig('put',url + '/' + action,data);
                        break;
                    case "get":
                        //httpPromise = $http.get(url + '/' + action );
                        config= new httpConfig('get',url + '/' + action);
                        break;
                    case "post":
                        config = new httpConfig('post', url + '/' + action, data);
                        break;
                    }


                    return thenFactoryMethod(config, successcb, errorcb,isArray);
                };

                Resource.putByParams = function(params, isArray, action, data, successcb, errorcb) {

                    var _params={};
                    if(!angular.isDefined(action)){
                        action="";
                    }
                    if(angular.isDefined(params.data.take))
                        _params.take=params.data.take;
                    if(params.data.firstPage) {
                        _params.page=1;
                        _params.skip=0;
                    }
                    else {
                        if(angular.isDefined(params.data.page))
                            _params.page=params.data.page;
                        if(angular.isDefined(params.data.skip))
                            _params.skip=params.data.skip;
                    }
                    if(angular.isDefined(params.data.pageSize))
                        _params.pageSize=params.data.pageSize;


                    var qs1=$.param(_params);
                    var qs2 = "";
                    var qs3 = "";
                    var qs ="";
                    if(params.data.filter) {
                        qs2=makeFilterQs(params.data.filter);
                        qs2 = '&'+qs2
                    }
                    if(params.data.sort) {
                        qs3=makeSortQs(params.data.sort);
                        qs3 = '&'+qs3
                    }
                    qs=qs1+qs2+qs3;  
                    if(qs) {
                        qs='?' +qs;
                    }
                    return thenFactoryMethod(new httpConfig('put', url + '/' + action + qs, data), successcb, errorcb, isArray);
                }

                Resource.getByParams = function (params, isArray,action,successcb, errorcb) {
                 
                    var _params={};
                    if(!angular.isDefined(action)){
                        action="";
                    }
                    if(angular.isDefined(params.data.take))
                        _params.take=params.data.take;
                    if(params.data.firstPage) {
                        _params.page=1;
                        _params.skip=0;
                    }
                    else {
                        if(angular.isDefined(params.data.page))
                            _params.page=params.data.page;
                        if(angular.isDefined(params.data.skip))
                            _params.skip=params.data.skip;
                    }
                    if(angular.isDefined(params.data.pageSize))
                        _params.pageSize=params.data.pageSize;

                    var qs1=$.param(_params);
                    var qs2=makeFilterQs(params.data.filter);
                    var qs3=makeSortQs(params.data.sort);
                    var qs=qs1+'&'+qs2+'&'+qs3;

                // var httpPromise = $http.get(url +action+ '?' + qs ); /*, {headers: {'Authorization': token}});*/


                    return thenFactoryMethod(new httpConfig('get',url +action+ '?' + qs ), successcb, errorcb,isArray);
                }
                Resource.getByIds = function (ids, successcb, errorcb) {
                    var qin = [];
                    angular.forEach(ids, function (id) {
                        qin.push({$oid: id});
                    });
                    return Resource.query({_id: {$in: qin}}, successcb, errorcb);
                };

                Resource.lov = function (successcb, errorcb) {
                // var httpPromise = $http.get(url + '/' + 'lov'); /*, {headers: {'Authorization': token}});*/
                 
                    return thenFactoryMethod(new httpConfig('get',url + '/' + 'lov' ), successcb, errorcb,true);
                };


            //instance methods

                Resource.prototype.$id = function () {
              
                    if(entityName=="PJPMaster")
                        return this.PjpMasterId;
                    return this[entityName+'Id'];
                /*if (this._id && this._id.$oid) {
                 return this._id.$oid;
                 }*/
                };

                Resource.prototype.$save = function (successcb, errorcb) {
                // var httpPromise = $http.post(url, this ); /*, {headers: {'Authorization': token}});*/
                    return thenFactoryMethod(new httpConfig('post',url,this), successcb, errorcb);
                };

                Resource.prototype.$update = function (successcb, errorcb) {
                // var httpPromise = $http.put(url, this ); /*, {headers: {'Authorization': token}});*/
                    return thenFactoryMethod(new httpConfig('put',url,this), successcb, errorcb);
                };

                Resource.prototype.$remove = function (successcb, errorcb) {
                // var httpPromise = $http['delete'](url + "/" + this.$id() ); /*, {headers: {'Authorization': token}});*/
                    return thenFactoryMethod(new httpConfig('delete',url + "/" + this.$id(),this), successcb, errorcb);
                };

                Resource.prototype.$saveOrUpdate = function (savecb, updatecb, errorSavecb, errorUpdatecb) {

                    if (this.$id()) {
                        return this.$update(updatecb, errorUpdatecb);
                    }
                    else {
                        return this.$save(savecb, errorSavecb);
                    }
                };

                Resource.prototype.$getDetail = function (successcb, errorcb) {
                // var httpPromise = $http.get(url + "/" + this[entityName+'Id'] ); /*, {headers: {'Authorization': token}});*/
                    return thenFactoryMethod(new httpConfig('get',url + "/" + this[entityName+'Id']), successcb, errorcb);
                };

                Resource.prototype.$getById = function (id, successcb, errorcb) {
                // var httpPromise = $http.get(url + '/' + this.$id()); /*, {headers: {'Authorization': token}});*/

                    return thenFactoryMethod(new httpConfig('get',(url + '/' + this.$id())), successcb, errorcb);
                };

                Resource.prototype.$activate = function (id, successcb, errorcb) {
                // var httpPromise = $http.put(url + '/Activate/' + id); /*, {headers: {'Authorization': token}});*/
                    return thenFactoryMethod(new httpConfig('put',url + '/Activate/' + id), successcb, errorcb);
                };

                Resource.prototype.$deactivate = function (id, successcb, errorcb) {
                // var httpPromise = $http.put(url + '/Deactivate/' + id); /*, {headers: {'Authorization': token}});*/
                    return thenFactoryMethod(new httpConfig('put',url + '/Deactivate/' + id), successcb, errorcb);
                };

                Resource.getUrlForAll=function(){
                    return url;
                };

                function makeFilterQs(filter){
                    var qs="";
                    var qsor = "";
                    var isComposite = false;
                    var singleQuote = "'";
                    var hasOr = false;
                    if (angular.isDefined(filter) && filter!=null) {


                        if(angular.isDefined(filter.compositeFilter) && filter.compositeFilter!=null) {
                            if(filter.compositeFilter.length>0) {

                                if(
                                    ((filter.compositeFilter[0].field.toLowerCase()).search("number") != -1 ||
                                (filter.compositeFilter[0].field.toLowerCase()).search("nationalidentifiervalue") != -1)
                                && filter.filters[0].value != ""){ //field = PhoneNumber
                                    {
                                        singleQuote="";
                                    }
                                }
                                else{
                                    singleQuote = "'";
                                }

                                qs = "filter=(" + filter.compositeFilter[0].field + "~" + filter.compositeFilter[0].operator + "~" + singleQuote + filter.compositeFilter[0].value + singleQuote;

                                for (var i = 1; i<filter.compositeFilter.length; i++) {
                                    if(
                                        ((filter.compositeFilter[i].field.toLowerCase()).search("number") != -1 ||
                                    (filter.compositeFilter[0].field.toLowerCase()).search("nationalidentifiervalue") != -1)
                                    && filter.filters[0].value != ""){ //field = PhoneNumber
                                        singleQuote="";
                                    }
                                    else{
                                        singleQuote = "'";
                                    }
                                    qs += "~" + "or" + "~" + filter.compositeFilter[i].field + "~" + filter.compositeFilter[i].operator + "~" + singleQuote
                                    + filter.compositeFilter[i].value + singleQuote;
                                }
                                qs += ")";
                                isComposite = true;
                            }

                        }
                        if(angular.isDefined(filter.addAsOr) && filter.addAsOr!=null) {
                            if(filter.addAsOr.length>0) {

                                if(
                                    ((filter.addAsOr[0].field.toLowerCase()).search("number") != -1 ||
                                (filter.addAsOr[0].field.toLowerCase()).search("nationalidentifiervalue") != -1)
                                && filter.filters[0].value != ""){ //field = PhoneNumber
                                    singleQuote="";
                                }
                                else{
                                    singleQuote = "'";
                                }

                                qsor = "filter=(" + filter.addAsOr[0].field + "~" + filter.addAsOr[0].operator + "~" + singleQuote + filter.addAsOr[0].value + singleQuote;
                                qsor += ")";
                                hasOr = true;
                            }

                        }
                        if(filter.filters.length>0) {

                            singleQuote = "'";
                            if(((filter.filters[0].field.toLowerCase()).search("number") != -1 ||
                            (filter.filters[0].field.toLowerCase()).search("nationalidentifiervalue") != -1)
                            && filter.filters[0].value != ""){ //field = PhoneNumber
                                singleQuote="";
                            }
                            if(((filter.filters[0].field.toLowerCase()).search("loanapplicationnumber") == 0)) {
                            // meanings loan application number filter is used in search
                                singleQuote = "'";
                            }
                            if(((filter.filters[0].field.toLowerCase()).search("accountapplicationnumber") == 0)) {
                                // meanings loan application number filter is used in search
                                    singleQuote = "'";
                                }
                            if (((filter.filters[0].field.toLowerCase()).search("transactionnumber") == 0)) {
                                // meanings transaction number filter is used in search
                                singleQuote = "'";
                            }
                        ///////////////////////////////////////////////////////////////////////////////////////////

                        //////////////////////////////////////////////////////////////////////////////////////////
                            if(isComposite) {
                                qs += "~and~(";
                                qs += filter.filters[0].field + "~" + filter.filters[0].operator + "~" + singleQuote + filter.filters[0].value + singleQuote;

                                for(var i=1; i<filter.filters.length; i++) {
                                    if(((filter.filters[i].field.toLowerCase()).search("number") != -1 ||
                                    (filter.filters[0].field.toLowerCase()).search("nationalidentifiervalue") != -1)
                                    && filter.filters[0].value != ""){ //field = PhoneNumber
                                        singleQuote="";
                                    }
                                    else{
                                        singleQuote = "'";
                                    }
                                    qs += "~" + filter.logic + "~" + filter.filters[i].field + "~" + filter.filters[i].operator + "~" + singleQuote +
                                    filter.filters[i].value + singleQuote;
                                }
                                qs += ")";
                            }
                            else if(hasOr) {
                                qs = qsor + "~or~(";
                                qs += filter.filters[0].field + "~" + filter.filters[0].operator + "~" + singleQuote + filter.filters[0].value + singleQuote;

                                for(var i=1; i<filter.filters.length; i++) {
                                    if(((filter.filters[i].field.toLowerCase()).search("number") != -1 ||
                                    (filter.filters[0].field.toLowerCase()).search("nationalidentifiervalue") != -1)
                                    && filter.filters[0].value != ""){ //field = PhoneNumber
                                        singleQuote="";
                                    }
                                    else{
                                        singleQuote = "'";
                                    }
                                    qs += "~" + filter.logic + "~" + filter.filters[i].field + "~" + filter.filters[i].operator + "~" + singleQuote +
                                    filter.filters[i].value + singleQuote;
                                }
                                qs += ")";

                            }
                            else {

                                qs = "filter=" + filter.filters[0].field + "~" + filter.filters[0].operator + "~" + singleQuote + filter.filters[0].value + singleQuote;

                                for(var i=1; i<filter.filters.length; i++) {
                                    if(((filter.filters[i].field.toLowerCase()).search("number") != -1 ||
                                    (filter.filters[0].field.toLowerCase()).search("nationalidentifiervalue") != -1)
                                    && filter.filters[0].value != ""){ //field = PhoneNumber
                                        singleQuote="";
                                    }
                                    else{
                                        singleQuote = "'";
                                    }
                                    qs += "~" + filter.logic + "~" + filter.filters[i].field + "~" + filter.filters[i].operator + "~" + singleQuote +
                                    filter.filters[i].value + singleQuote;
                                }
                            }
                        }

                    }
                    return qs;
                }
                function makeSortQs(sort){
                    var qs="";
                 
                    if (angular.isDefined(sort) && sort.length>0){
                        if(sort[0].field=="Status" || sort[0].filed=="DeviceStatus" || sort[0].field=="DeviceStatus") {
                            if(entityName=="ProcessInstance") {
                                sort[0].field="Status";
                            }


                        }

                        if(sort[0].field=="Status") {
                        //qs = "orderby=" + sort[0].field + "-" + sort[0].dir;
                            qs = "sort=" + sort[0].field + "-" + sort[0].dir;

                        }
                        else {
                            qs = "sort=" + sort[0].field + "-" + sort[0].dir;

                        }

                    }
                    //else{
                        // if(entityName=="LoanApplication")
                        //     qs="sort=LoanApplicationId-desc";
                //     else if(entityName!="ProcessInstance"&&entityName!="privileges")
                //         qs = "sort=EffectiveEndDate-desc";
                    //}
                    return qs;
                }


                return Resource;
            }

            return tmxResourceFactory;
        }]);
})();
